<template>
  <v-card>
    <v-card-text class="text-left">
      Mon Profil d'Administrateur
    </v-card-text>
    <v-card-actions>
      <Navigation :elements="AdminNavigation" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  computed: {
    ...mapState({
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
